const sortBy = document.querySelector(".js-sort-by");
if (sortBy) {
  // When choosing a select option, update the URL params and reload
  let params = new URLSearchParams(window.location.search);
  sortBy.addEventListener("change", (e) => {
    e.preventDefault();
    params.set("sort_by", e.target.value);
    window.location.search = params.toString();
  });
  // Set the active value on page load
  const sortByCurrent = params.get("sort_by");
  if (sortByCurrent) {
    sortBy.value = sortByCurrent;
  }
}
